import React from 'react';

interface StatusBadgeProps {
    status: string;
    /**
     * Optional display text. Defaults to `status`, so every pre-existing call site
     * (ContainerAppsList, ContainerAppDetailsPage, StatusDashboardPage) is unaffected.
     */
    label?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, label }) => {
    let bgColor, textColor;

    switch (status.toLowerCase()) {
        case 'running':
            bgColor = 'bg-green-100 dark:bg-green-900';
            textColor = 'text-green-800 dark:text-green-200';
            break;
        case 'stopped':
            bgColor = 'bg-red-100 dark:bg-red-900';
            textColor = 'text-red-800 dark:text-red-200';
            break;
        case 'warning':
            bgColor = 'bg-yellow-100 dark:bg-yellow-900';
            textColor = 'text-yellow-800 dark:text-yellow-200';
            break;
        case 'starting':
            bgColor = 'bg-blue-100 dark:bg-blue-900';
            textColor = 'text-blue-800 dark:text-blue-200';
            break;
        // ── Tenant readiness states (server/services/readiness) ──────────────
        // ok / fail / blocked / warn / unknown. `blocked` is deliberately a
        // darker slate than `unknown`'s plain gray: "an upstream check stopped
        // this one" must not look the same as "nobody has checked yet".
        case 'ok':
            bgColor = 'bg-green-100 dark:bg-green-900';
            textColor = 'text-green-800 dark:text-green-200';
            break;
        case 'fail':
            bgColor = 'bg-red-100 dark:bg-red-900';
            textColor = 'text-red-800 dark:text-red-200';
            break;
        case 'warn':
            bgColor = 'bg-yellow-100 dark:bg-yellow-900';
            textColor = 'text-yellow-800 dark:text-yellow-200';
            break;
        case 'blocked':
            bgColor = 'bg-slate-200 dark:bg-slate-700';
            textColor = 'text-slate-700 dark:text-slate-200';
            break;
        case 'unknown':
            bgColor = 'bg-gray-100 dark:bg-gray-700';
            textColor = 'text-gray-800 dark:text-gray-300';
            break;
        default:
            bgColor = 'bg-gray-100 dark:bg-gray-700';
            textColor = 'text-gray-800 dark:text-gray-300';
    }

    return (
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${bgColor} ${textColor}`}>
            {label ?? status}
        </span>
    );
};

export default StatusBadge;
